<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="fornecedores.content"
      class="elevation-1 mt-5 rounded-card"
      :loading="loading"
      :server-items-length="fornecedores.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum fornecedor encontrado"
      loading-text="Carregando fornecedores..."
      :options="optionsList"
    >
      <template v-slot:item.codigoInterno="{ item }">
        <px-span-tooltip top :text="codigoInterno(item)" :tooltip="labelCodigoInterno(item)"/>
      </template>
      <template v-slot:item.nome="{ item }">
        {{ item.nome || item.fornecedor.pessoa.nome }}
        <v-tooltip v-if="item.transportadora" top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="info" small>mdi-truck</v-icon>
          </template>
          <span>Transportadora</span>
        </v-tooltip>
      </template>
      <template v-slot:item.cnpj="{ item }">
        <px-fornecedor-documento :fornecedor="item.fornecedor"/>
      </template>
      <template v-slot:item.permiteEdicaoCotacao="{ item }">
        <div class="d-flex justify-center">
          <px-switch-tooltip
            v-model="item.permiteEdicaoCotacao"
            @change="updatePermiteEdicaoCotacao(item)"
            tooltip="Habilita a edição das respostas submetidas por este fornecedor no<br>
              processo de cotação, desde que não possua negociação em aberto."/>
        </div>
      </template>
      <template v-slot:item.situcacao="{ item }">
        <div class="d-flex justify-center">
          <px-ativo :ativo="!item.fornecedor.disabled && item.ativo"/>
        </div>
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon link :to="`fornecedor/${item.id}`">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
        <v-btn v-if="hasRoleComprador"
               icon
               :disabled="!isNacional(item.fornecedor) && !isPessoaFisica(item.fornecedor)"
               @click="onClickRemove(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { TipoFornecedor } from 'px-business-components';
import GestaoFornecedorService from './gestao-fornecedor-service';

export default {
  props: {
    fornecedores: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
    footerOptions: Object,
  },
  data() {
    return {
      headers: [
        {
          text: 'Código',
          value: 'codigoInterno',
        },
        {
          text: 'Nome',
          value: 'nome',
        },
        {
          text: 'Documento',
          value: 'cnpj',
        },
        {
          text: 'Editar cotações',
          value: 'permiteEdicaoCotacao',
          align: 'center',
          width: '150px',
          sortable: false,
        },
        {
          text: 'Situação',
          value: 'situcacao',
          align: 'center',
          width: '150px',
          sortable: false,
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    isNacional() {
      return fornecedor => fornecedor.tipo === TipoFornecedor.keys.NACIONAL.key;
    },
    isPessoaFisica() {
      return fornecedor => fornecedor.tipoFilho === TipoFornecedor.keys.PESSOA_FISICA.key;
    },
    codigoInterno() {
      return (fornecedor) => {
        if (fornecedor.codigoTransportadora && fornecedor.codigoInterno) {
          return `${fornecedor.codigoInterno} / ${fornecedor.codigoTransportadora}`;
        }
        return Vue.filter('naoInformado')(fornecedor.codigoTransportadora || fornecedor.codigoInterno);
      };
    },
    labelCodigoInterno() {
      return (fornecedor) => {
        if (fornecedor.codigoTransportadora && fornecedor.codigoInterno) {
          return 'Código interno fornecedor / Código interno transportadora';
        }
        return fornecedor.codigoTransportadora ? 'Código interno transportadora' : 'Código interno';
      };
    },
  },
  methods: {
    updatePermiteEdicaoCotacao(item) {
      this.loading = true;
      const payload = {
        id: item.id,
        permiteEdicaoCotacao: item.permiteEdicaoCotacao,
      };
      GestaoFornecedorService.updatePermiteEdicaoCotacao(payload)
        .then(() => {
          this.$toast('Fornecedor atualizado com sucesso', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    remove(item) {
      GestaoFornecedorService.remove(item.id)
        .then(() => {
          this.$toast('Fornecedor removido', { color: 'success' });
          this.emitUpdate();
        });
    },
    onClickRemove(item) {
      this.$refs.confirm.open('Você deseja remover este fornecedor?',
        'O fornecedor será removido e esta operação não pode ser desfeita.',
        { width: 330 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
};
</script>
